import { render, staticRenderFns } from "./Payment-schedule-details.vue?vue&type=template&id=2d8340dc&scoped=true"
import script from "./Payment-schedule-details.vue?vue&type=script&lang=js"
export * from "./Payment-schedule-details.vue?vue&type=script&lang=js"
import style0 from "./Payment-schedule-details.vue?vue&type=style&index=0&id=2d8340dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8340dc",
  null
  
)

export default component.exports